module.exports = __webpack_public_path__ + "img/manage-account-dark-theme.20a095a8.svg";